<template>
    <div class="mt-4 mb-3">
        <div class="alert alert-warning mb-0 lh-small d-flex align-items-center" v-if="billing_hold">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            <p class="card-title mb-0">Charge failed when shipping product on this order, please update your payment method
            </p>
        </div>

        <div class="card-body">
            <SelectCard :cards="payment.cards" class="mt-2" :form="form" :has_linked="has_linked"
                @setPaymentMethod="setPaymentMethod" />

            <SelectAccount :banks="payment.banks" :link_token="link_token" :form="form" class="mt-3"
                bankRoute="mtd.cart.addBank" :form_bank="formBank" :bank_discount_percent="payment.bank_discount_percent"
                :has_linked="has_linked" @bankAdded="updateSelected" />

            <div class="bottom-button pt-3 mt-2 border-top">
                <jet-button class="px-5" btnStyle="success" :disable="form.processing" @click="saveMethod">Update Default
                    Payment Method</jet-button>
            </div>

        </div>

        <AddCard :routeUrl="route('mtd.cart.addCard')" :formCard="formCard" @cardUpdated="updateSelected" />

    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import toastr from 'toastr'
import moment from 'moment'
import SelectAccount from '@/Components/Payment/SelectAccount'
import SelectCard from '@/Components/Payment/SelectCard'
import AddCard from '@/Components/Modals/AddCard'
import AmountInput from '@/Shared/AmountInput'

export default {
    components: {
        AppLayout,
        FlashMessages,
        JetDialogModal,
        JetDangerButton,
        AddCard,
        SelectAccount,
        SelectCard,
        AmountInput
    },
    props: {
        payment: Object,
        updateMethodRoute: String,
        billing_hold: {
            type: Boolean,
            default: false
        },
        has_linked: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            link_token: this.payment.link_token,
            bankProcessing: false,
            cardProcessing: false,
            form: this.$inertia.form({
                payment_amount_type: 'due',
                payment_intent: this.payment.payment_intent,
                payment_amount: null,
                stripe_payment_method: this.payment.payment_method_id
            }),
            formCard: this.$inertia.form({
                card_name: null,
                card_number: null,
                card_exp_month: null,
                card_exp_year: null,
                card_cvc: null,
                card_zip: null,
            }),
            formBank: this.$inertia.form({
                public_token: null,
                account_id: null
            }),
        }
    },
    created() {
        this.moment = moment;
    },
    methods: {
        deleteCard(card) {
            this.cardProcessing = true
            this.$inertia.visit(route('cart.deleteMethod', card), {
                onSuccess: () => this.cardProcessing = false,
                onFinish: () => this.cardProcessing = false
            })
        },
        saveMethod() {
            if (!this.form.stripe_payment_method) {
                toastr.error("Please select a payment method");
            } else {
                console.log(this.form)
                this.form.post(this.updateMethodRoute);
            }
        },
        setPaymentMethod(e, id) {
            this.form.stripe_payment_method = id;
        },
        updateSelected() {
            console.log(this.payment.payment_method_id)
            this.form.stripe_payment_method = this.payment.payment_method_id;
            console.log('spm', this.form.stripe_payment_method)
        },
    },
    computed: {
        paymentAmount() {
            switch (this.form.payment_amount_type) {
                case 'due':
                    return this.payment.dueTotal;
                case 'total':
                    return this.payment.unpaidTotal;
                case 'other':
                    if (parseFloat(this.form.payment_amount) > 0) {
                        return this.form.payment_amount;
                    }
            }
            return 0;
        }
    }
}
</script>
